export const createList = (className) => {
  const ul = document.createElement(`ul`);
  ul.className = className;

  return ul;
};
